import { render, staticRenderFns } from "./ConfiguracionComisionesEspecialista.vue?vue&type=template&id=7ce54e7a&scoped=true"
import script from "./ConfiguracionComisionesEspecialista.vue?vue&type=script&lang=js"
export * from "./ConfiguracionComisionesEspecialista.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionComisionesEspecialista.vue?vue&type=style&index=0&id=7ce54e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce54e7a",
  null
  
)

export default component.exports